import React, { useState } from "react";
import { Form, Container, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function ThermalRoll({ navigation, primaryDetails, setPrimaryDetails }) {
  const [errors, setErrors] = useState({});

  const STOCK_OPTIONS = [
    "0",
    "1 to 2",
    "3 to 4",
    "5 to 6",
    "7 to 8",
    "9 to 10",
    "more than 10",
    "overstock"
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: false }));
  };

  const validate = () => {
    const newErrors = {
      thermal_roll_stock: !primaryDetails.thermal_roll_stock,
      thermal_roll_delivery: !primaryDetails.thermal_roll_delivery,
    };

    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some(Boolean);

    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleNext = () => {
    if (validate()) {
      // Navigate based on thermal roll delivery selection
      if (primaryDetails.thermal_roll_delivery === 'Yes') {
        navigation.go('thermal-roll-delivery-yes');
      } else if (primaryDetails.thermal_roll_delivery === 'No') {
        navigation.go('charger-delivery');
      }
    }
  };

  const handleBack = () => {
    if (navigation && navigation.previous) navigation.previous();
  };

  // Check if form is valid for visual feedback
  const isFormValid = () => {
    const isValid = primaryDetails.thermal_roll_stock &&
     primaryDetails.thermal_roll_delivery;
     return isValid; 
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          {/* Main Form */}
          <Col md={10}>
              <div className="form-main-header">
                <h4 className="form-title">THERMAL ROLL</h4>
                <p className="form-desc">Please provide thermal roll information</p>
              </div>
              <div className="form-main">
              <div className="form-main-content">
              <Form>
                {/* Current stock of thermal roll */}
                <Form.Group className={`mb-4${errors.thermal_roll_stock ? ' form-group-error' : ''}`}>
                  <Form.Label className="form-label">
                    Current stock of thermal roll <span className="form-required">*</span>
                  </Form.Label>
                  <Form.Select
                    name="thermal_roll_stock"
                    value={primaryDetails.thermal_roll_stock || ""}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="">Select stock level</option>
                    {STOCK_OPTIONS.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </Form.Select>
                  {errors.thermal_roll_stock && (
                    <div className="form-error">
                      Required
                    </div>
                  )}
                </Form.Group>

                {/* Thermal roll delivery */}
                <Form.Group className={`mb-4${errors.thermal_roll_delivery ? ' form-group-error' : ''}`}>
                  <Form.Label className="form-label">
                    Thermal roll delivery <span className="form-required">*</span>
                  </Form.Label>
                  <div className="form-radio-group">
                    {['Yes', 'No'].map((val) => (
                      <div key={val} className="form-radio-item">
                        <div className="form-radio-flex">
                          <Form.Check
                            type="radio"
                            label={val}
                            name="thermal_roll_delivery"
                            value={val}
                            checked={primaryDetails.thermal_roll_delivery === val}
                            onChange={handleChange}
                            className="form-radio"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                  {errors.thermal_roll_delivery && (
                    <div className="form-error">
                      Required
                    </div>
                  )}
                </Form.Group>
                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back 
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                       Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ThermalRoll;
